import type { UseQueryResult } from '@tanstack/react-query';
import { useQuery } from '@tanstack/react-query';
import type { AxiosError } from 'axios';
import { useMemo } from 'react';
import { useClient } from '../../client-api';
import { getGeneralSettings, type MonteCarloGeneralSettingsDto } from '../../generated/client';
import { queryKeys } from '../../query-keys';

export function useGeneralProjectionSettings(): UseQueryResult<MonteCarloGeneralSettingsDto, AxiosError> {
    const { data: client } = useClient();
    const queryKey = useMemo(() => queryKeys.saeCashFlowProjectionGeneralSettings(client?.partnerUuid), [client?.partnerUuid]);

    return useQuery({
        queryKey,
        queryFn: ({ signal }) => getGeneralSettings({ query: { clientId: client!.id }, signal }).then((result) => result.data),
        enabled: !!client,
    });
}
